// Shared react-select (v5) style overrides → Bravo DS look.
// Used by the MultiChoice base and SourceQuestionSelect. Token strings resolve
// against :root, so this works even when the menu is portaled to document.body
// (outside the .bravo-ds subtree). Single-selects simply ignore the multiValue keys.
const dsSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '40px',
    borderRadius: 'var(--radius-sm)',
    borderColor: state.isFocused ? 'var(--navy)' : 'var(--line-strong)',
    backgroundColor: 'var(--surface)',
    boxShadow: state.isFocused ? '0 0 0 3px color-mix(in srgb, var(--navy) 14%, transparent)' : 'none',
    fontFamily: 'var(--font)',
    fontSize: '14px',
    '&:hover': { borderColor: 'var(--navy)' },
  }),
  menu: (base) => ({
    ...base,
    // Without an explicit background the menu falls back to react-select's default white,
    // which in dark mode is a white panel with light (unreadable) option text.
    backgroundColor: 'var(--surface)',
    borderRadius: 'var(--radius-sm)',
    border: '1px solid var(--line)',
    boxShadow: 'var(--shadow-md)',
    overflow: 'hidden',
    zIndex: 20,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 2000 }),
  menuList: (base) => ({
    ...base,
    textAlign: 'left',
    maxHeight: '160px',
    padding: '4px',
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: '6px',
    fontSize: '13px',
    color: state.isSelected ? '#fff' : 'var(--ink)',
    backgroundColor: state.isSelected
      ? 'var(--navy)'
      : state.isFocused
      ? 'var(--surface-2)'
      : 'transparent',
    '&:active': { backgroundColor: 'var(--surface-2)' },
  }),
  multiValue: (base) => ({
    ...base,
    borderRadius: '999px',
    backgroundColor: 'color-mix(in srgb, var(--navy) 10%, var(--surface))',
    border: '1px solid color-mix(in srgb, var(--navy) 20%, transparent)',
  }),
  multiValueLabel: (base) => ({
    ...base,
    // --ink (not --navy) so the pill label is dark on light and light on dark — navy is
    // near-invisible on the dark pill fill in dark mode.
    color: 'var(--ink)',
    fontWeight: 700,
    fontSize: '12px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--ink-2)',
    borderRadius: '0 999px 999px 0',
    '&:hover': { backgroundColor: 'var(--red)', color: '#fff' },
  }),
  placeholder: (base) => ({ ...base, color: 'var(--ink-3)' }),
  input: (base) => ({ ...base, color: 'var(--ink)' }),
  singleValue: (base) => ({ ...base, color: 'var(--ink)' }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--line)' }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? 'var(--navy)' : 'var(--ink-3)',
    '&:hover': { color: 'var(--navy)' },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'var(--ink-3)',
    '&:hover': { color: 'var(--red)' },
  }),
};

export default dsSelectStyles;
